import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['search', 'option', 'dropdown', 'tags', 'counter']

  handleOutsideClick = (event) => {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  connect() {
    this.defaultPlaceholder = this.searchTarget.placeholder
    this.renderTags()
    document.addEventListener('click', this.handleOutsideClick)
  }

  disconnect() {
    document.removeEventListener('click', this.handleOutsideClick)
  }

  open() {
    this.dropdownTarget.classList.remove('hidden')
  }

  close() {
    this.dropdownTarget.classList.add('hidden')
    this.searchTarget.value = ''
    this.filter()
  }

  openOnClick(event) {
    if (event.target.closest('button')) return
    this.searchTarget.focus()
    this.open()
  }

  filter() {
    const query = this.searchTarget.value.toLowerCase().trim()
    this.optionTargets.forEach((option) => {
      const matches = option.dataset.label.toLowerCase().includes(query)
      option.classList.toggle('hidden', query.length > 0 && !matches)
    })
  }

  update() {
    this.renderTags()

    if (!this.hasCounterTarget) return

    const count = this.checkedOptions().length
    this.counterTarget.textContent = count > 0 ? `(${count})` : ''
  }

  removeTag(event) {
    const button = event.target.closest('button[data-code]')
    if (!button) return

    event.stopPropagation()

    const option = this.optionTargets.find((opt) => opt.dataset.code === button.dataset.code)
    if (!option) return

    const checkbox = option.querySelector('input[type=checkbox]')
    if (checkbox) checkbox.checked = false

    this.renderTags()
  }

  checkedOptions() {
    return this.optionTargets.filter((opt) => opt.querySelector('input[type=checkbox]')?.checked)
  }

  renderTags() {
    this.tagsTarget.innerHTML = ''
    const checked = this.checkedOptions()
    this.searchTarget.placeholder = checked.length > 0 ? '' : this.defaultPlaceholder
    checked.forEach((opt) => {
      const tag = document.createElement('span')
      tag.className =
        'inline-flex items-center gap-1 rounded-md px-2 py-0.5 text-sm text-on-surface text-primary-600 bg-primary-100 hover:bg-primary-200'

      const label = document.createElement('span')
      label.textContent = opt.dataset.label

      const button = document.createElement('button')
      button.type = 'button'
      button.className = 'text-primary-600 hover:text-primary-900leading-none cursor-pointer'
      button.dataset.code = opt.dataset.code
      button.setAttribute('aria-label', `Retirer ${opt.dataset.label}`)
      button.textContent = '×'

      tag.appendChild(label)
      tag.appendChild(button)
      this.tagsTarget.appendChild(tag)
    })
  }
}
